class Radio {

    constructor() {

        const magazineForm = document.querySelector('.magazine form');

        if (!magazineForm) {
            return;
        }

        const magazineTypeInputs = magazineForm.elements['data[MagazineRequest][type]'];

        const magazineAdresInput = magazineForm.querySelector('#MagazineRequestAdres');
        const magazineSubmitButton = magazineForm.querySelector('button[type="submit"]');

        magazineTypeInputs.forEach((magazineType) => {
            magazineType.addEventListener('change', (event) => {

                let radioValue = event.target.value;
                let adresError = magazineAdresInput.nextSibling;

                if (radioValue === 'digitaal') {

                    magazineAdresInput.style.setProperty('display', 'none');
                    magazineSubmitButton.textContent = 'Downloaden';

                    if (adresError.classList.contains('error-message')) {
                        adresError.style.setProperty('display', 'none');
                    }

                } else {

                    magazineAdresInput.style.removeProperty('display');
                    magazineSubmitButton.textContent = 'Aanvragen';

                    if (adresError.classList.contains('error-message')) {
                        adresError.style.removeProperty('display');
                    }

                }

            });
        });

    }

}

new Radio();